// extracted by mini-css-extract-plugin
module.exports = {"major":"Home_major__JXQjT","profile":"Home_profile__RxgtQ","about":"Home_about__10cTa"};